require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-bs-spotify-web-api.json") })
        }
      }, "path---package-bs-spotify-web-api");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-bs-spotify-web-api!./.cache/json/package-bs-spotify-web-api.json
// module id = 840
// module chunks = 231608221292675